import { Button, Box, Typography, TableCell, TableRow, Tooltip } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import React from 'react'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { withStyles } from "@material-ui/core/styles";
import moment from 'moment';
const LightTooltip = withStyles((theme) => ({
    tooltip: { backgroundColor: "#fff", color: "#000", boxShadow: "0px 4px 12px rgba(0,0,0,0.15)", fontSize: 12, padding: "12px", borderRadius: "5px", maxWidth: 220, },
    arrow: { color: "#fff", },
}))(Tooltip);
function AuditListing({ item, onSftpChange }) {
    return (
        <>
            <TableRow>
                <TableCell>{item?.action_type || '--'}</TableCell>
                <TableCell>{item?.created_at || '--'}</TableCell>
                <TableCell style={{ color: item?.status === 'SUCCESS' ? '#210eaeff' : 'red', fontWeight: '600', minWidth: '110px' }}>{item?.status || '--'}</TableCell>
                <TableCell>{item?.folder_path || '--'}</TableCell>
                <TableCell >{item?.file_name || '--'}
                    <Tooltip title={item?.file_path ? "Click to download" : ''}>
                        <GetAppIcon style={{ cursor: 'pointer', color: '#bd10e0', verticalAlign: "Bottom", color: '#bd10e0', fontSize: 'large', paddingLeft: '4px' }} onClick={(e) => item?.file_path ? window.open(decodeURIComponent(item.file_path), "_self") : e.preventDefault()} />
                    </Tooltip>
                </TableCell>
                <TableCell>{item?.notified_emails || '--'}</TableCell>
                <TableCell>
                    <Button color='secondary' onClick={() => onSftpChange(item?.id)} style={{textAlign:'left'}}>Sync to Hanwha</Button>
                </TableCell>
                <TableCell>
                    <LightTooltip
                        arrow
                        placement="right"
                        enterDelay={100}
                        interactive={true}
                        title={item?.sftp_uploaded_files?.length > 0 ?
                            <Box>
                                <Typography style={{ fontSize: 15, fontWeight: 600, marginBottom: 6, }} > Uploaded Files </Typography>
                                {item?.sftp_uploaded_files?.map((file, index) => (
                                    <Box key={index} display="flex" alignItems="center" mb={1} >
                                        <Box>
                                            <Typography style={{ fontSize: 13, fontWeight: 600, }} > {file?.file_name || "-"} </Typography>
                                            <Typography style={{ fontSize: 12, color: "#bdbdbd", }} > {file?.uploaded_at ? moment(file?.uploaded_at).format("DD MMM YYYY, HH:mm") : "-"} </Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box> : 'No File Found'
                        }
                    >
                        <MoreVertIcon color="primary" style={{ cursor: "pointer" }} />
                    </LightTooltip>
                </TableCell>
            </TableRow>
        </>
    )
}

export default AuditListing